import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

import principalImage from "../../assests/exco/principal.webp";

import activePresidnet from "../../assests/exco/active_president.webp";

export default function MessagesSectionComponent() {
  const messages = [
    {
      id: 1,
      name: "Mrs. H G M Jayamali",
      position: "Principal, Vidyaloka College",
      image: principalImage,
      title: "Message from the Principal",
      message:
        "It is with great pride and joy that I address you as the Principal of Vidyaloka College. Old Boys' Association of Vidyaloka College has always been committed to nurturing young minds, fostering excellence in education, and building character. The Old Boys' Association plays a vital role in maintaining the spirit and legacy of our beloved college. I encourage all alumni to stay connected, contribute to the growth of our community, and inspire current students with your achievements. Together, we continue to uphold the values and traditions that make Vidyaloka College a beacon of excellence.",
      imagePosition: "right",
      fade: "left",
    },
    {
      id: 2,
      name: "Mr. Sampath Duminda De Silva",
      position: "Active President, Vidyaloka College Old Boys' Association",
      image: activePresidnet,
      title: "Message from the Active President",
      message:
        "As the Active President of the Vidyaloka College Old Boys' Association, I am honored to lead this esteemed community of distinguished alumni. Our association stands as a testament to the enduring bonds forged within the halls of Vidyaloka College. We are committed to supporting our alma mater, mentoring current students, and creating opportunities for our members to reconnect and collaborate. I invite all old boys to actively participate in our initiatives, contribute to our development programs, and help us build a stronger network that benefits both our college and our members. Together, we can create a lasting impact.",
      imagePosition: "right",
      fade: "right",
    },
  ];

  return (
    <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container px-3">
        {messages.map((msg, index) => (
          <div
            key={msg.id}
            className={`${index === messages.length - 1 ? "" : "mb-5"}`}
            data-aos={msg.fade === "left" ? "fade-right" : "fade-left"}
          >
            <div className="card rounded-3 border-vcg-muted">
              <div className="card-body p-0">
                <div className="row g-0">
                  {/* Image Section - Left */}
                  {msg.imagePosition === "left" && (
                    <div className="col-lg-4 d-flex align-items-center justify-content-center px-4 pt-3 pb-4 p-lg-5">
                      <div className="text-center">
                        <div className="mb-3">
                          <img
                            src={msg.image}
                            alt={msg.name}
                            className="rounded-3 border-vcg-muted img-fluid"
                            style={{
                              width: "250px",
                              height: "250px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        <h5 className="fw-bold mb-1">{msg.name}</h5>
                        <p className="text-muted small mb-0">{msg.position}</p>
                      </div>
                    </div>
                  )}

                  {/* Message Section */}
                  <div className="col-lg-8 d-flex align-items-center p-4 p-lg-5">
                    <div>
                      <h3 className="fw-bold mb-4">{msg.title}</h3>

                      <div className="mb-3">
                        <FontAwesomeIcon
                          icon={faQuoteLeft}
                          size="2x"
                          style={{ color: "#000000", opacity: 0.3 }}
                        />
                      </div>

                      <p className="mb-0 text-secondary">{msg.message}</p>
                    </div>
                  </div>

                  {/* Image Section - Right */}
                  {msg.imagePosition === "right" && (
                    <div className="col-lg-4 d-flex align-items-center justify-content-center px-4 pt-3 pb-4 p-lg-5">
                      <div className="text-center">
                        <div className="mb-3">
                          <img
                            src={msg.image}
                            alt={msg.name}
                            className="rounded-3 border-vcg-muted img-fluid"
                            style={{
                              width: "250px",
                              height: "250px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        <h5 className="fw-bold mb-1">{msg.name}</h5>
                        <p className="text-muted small mb-0">{msg.position}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
